import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-roads',
  templateUrl: './roads.component.html',
  styleUrls: ['./roads.component.scss']
})
export class RoadsComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Roads');  
  }

}
